<template>
    <v-tooltip v-model="show" top >
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" >
                <v-icon :color="color">
                    mdi-information
                </v-icon>
            </v-btn>
        </template>
        <span>{{text}}</span>
    </v-tooltip>
</template>

<script>
    export default {
        data() {
            return {
                show: false
            }
        },
        props:['text','color']
    }
</script>

<style>

</style>